export default __webpack_public_path__ + "static/media/BOLD_unpressed.cb633ac2.svg";